import { withFormik } from "formik";

import ScreenWidth from "components/hoc/ScreenWidth";

import UserConfirmForm from "./UserConfirmForm";

export default withFormik({
  form: "user",
  mapPropsToValues: ({ user }) => ({
    ...user,
  }),
  handleSubmit: (values, { props: { onSubmit }, setSubmitting }) =>
    onSubmit(values).finally(() => setSubmitting(false)),
})(ScreenWidth(UserConfirmForm));
